// Se piensa deprecar este modulo y usar
// para los errores usamos dispatch('notifications/showRequestError')

const state = {
  isToastErrorVisible: false,
  errorObject: {
    error: '',
    message: '',
    statusCode: ''
  }
}
const mutations = {
  mutateShowToast (state, error) {
    state.errorObject = error
    state.isToastErrorVisible = true
  },
  mutateHideToast (stater) {
    state.isToastErrorVisible = false
  }
}
const actions = {
  async actionShowToastError ({ commit, rootState }, error) {
    if (rootState.session.isAuthenticated) {
      commit('mutateShowToast', error)
    }
  },
  async actionHideToastError ({ commit }) {
    commit('mutateHideToast')
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
